import {filter, groupBy, keys, map} from 'lodash';
import {consolidateSchoolYears, MONTH_ABBRVS} from 'shared/utils';

// student-profile
import StudentData from './student-data';
import {courseGroupingKey} from 'portfolio/components/bulk-entry/utils';
import {classYearsMap, schoolYears} from 'shared/portfolio/utils';
import {CURRENT_SCHOOL_YEAR} from 'shared/utils';

export default class HighSchoolStudentData extends StudentData {
  constructor({student, collegeDataForStudent, hideSensitiveDemographics}) {
    super({student, collegeDataForStudent, hideSensitiveDemographics});
    this.info = student.highSchoolInfo || {};
  }

  matriculationText = () => `Class of ${this.matriculationYear()}`;

  gpaExplanationText = () => 'Unweighted GPA';

  isFrl = () => (this.hideSensitiveDemographics ? null : this.info.lunchPlan === 'FRL');

  matriculationYear = () => this.info.graduationYear;

  studentSchoolYears = () => map(schoolYears(this.matriculationYear()), 'name');

  currentAndPastYearSchoolYears = () =>
    filter(this.studentSchoolYears(), (schoolYearRange) => {
      const endYear = parseInt(schoolYearRange.split('-')[1]);
      return endYear <= CURRENT_SCHOOL_YEAR;
    });

  // for high school students even if they don't have courses we still show the empty sections
  // for all of their school years
  hasCourses = () => true;

  courses = () => {
    const coursesForYear = groupBy(this.portfolio.courses, 'schoolYear');

    return map(this.currentAndPastYearSchoolYears(), (schoolYear) => {
      const courses = coursesForYear[schoolYear];
      const schoolYearEnd = parseInt(schoolYear.split('-')[1]);

      return {
        term: schoolYear,
        termText: `${classYearsMap[this.matriculationYear() - schoolYearEnd]} Year`,
        groupedCourses: groupBy(courses, (course) => JSON.stringify(courseGroupingKey(course))),
      };
    });
  };

  hasPerfectAttendance = () => !!this.schoolYearsWithPerfectAttendance().length;

  schoolYearsWithPerfectAttendance = () => {
    const attendance = this.portfolio.attendance;
    return filter(keys(attendance), (schoolYear) => attendance[schoolYear] === 0);
  };

  attendance = () => ({
    name: 'Perfect Attendance',
    subtitle: consolidateSchoolYears(this.schoolYearsWithPerfectAttendance()).join(', '),
  });

  hasFafsaSubmission = () =>
    !!this.student.fafsaSubmission && !!this.student.fafsaSubmission.submittedAtYear;

  fafsaSubmission = () => {
    const {submittedAtMonth, submittedAtYear} = this.student.fafsaSubmission;

    return {
      name: 'Submitted the FAFSA',
      subtitle: `${MONTH_ABBRVS[submittedAtMonth]} ${submittedAtYear}`,
    };
  };
}
